import React from "react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();

  const pathnames = location.pathname.split("/").filter(Boolean);

  const isCityUrl = pathnames[0] === "city";
  const citySlug = isCityUrl ? pathnames[1] : null;

  const homeUrl = citySlug ? `/city/${citySlug}` : "/";

  // Remove /city/dubai from breadcrumb display
  const breadcrumbPathnames = isCityUrl
    ? pathnames.slice(2)
    : pathnames;

  return (
    <div className="mx-6 my-4 ">
      <Link to={homeUrl}>
        Home
      </Link>

      {breadcrumbPathnames.map((value, index) => {
        const to = citySlug
          ? `/city/${citySlug}/${breadcrumbPathnames
              .slice(0, index + 1)
              .join("/")}`
          : "/" +
            breadcrumbPathnames.slice(0, index + 1).join("/");

        return (
          <span key={to}>
            {" / "}
            <Link to={to}>
              {value
                .replace(/-/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase())}
            </Link>
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
